/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';

import { Form } from '@organisms';

import ArticlesByTag from '../ArticlesByTag';

const ArticlesByTagField = (props) => (
  <Form.WithFieldValue name={props.name}>
    {(_, form) => (
      <Form.Item {...props}>
        <ArticlesByTag onClear={() => form.setFields([{ name: props.name, value: undefined, errors: [] }])} />
      </Form.Item>
    )}
  </Form.WithFieldValue>
);

export default ArticlesByTagField;
